class VehicleStorage {
  constructor() {
    this.keys = {
      vehicles: 'maxtondesign_saved_vehicles',
      selected: 'maxtondesign_selected_vehicle'
    };
  }

  async saveVehicles(vehicles) {
    const data = JSON.stringify(vehicles);

    if (this.supportsLocalStorage()) {
      localStorage.setItem(this.keys.vehicles, data);
    }

    if (this.isCustomerLoggedIn()) {
      await this.syncToAccount(vehicles);
    }

    return true;
  }

  async loadVehicles() {
    let data = null;

    if (this.supportsLocalStorage()) {
      data = localStorage.getItem(this.keys.vehicles);
    }

    if (data) {
      try {
        return JSON.parse(data);
      } catch (error) {
        await this.clear();
        return [];
      }
    }

    return [];
  }

  async saveSelected(vehicleName) {
    if (this.supportsLocalStorage()) {
      localStorage.setItem(this.keys.selected, vehicleName || '');
    }
    return true;
  }

  async loadSelected() {
    if (this.supportsLocalStorage()) {
      return localStorage.getItem(this.keys.selected);
    }
    return null;
  }

  async clear() {
    if (this.supportsLocalStorage()) {
      localStorage.removeItem(this.keys.vehicles);
      localStorage.removeItem(this.keys.selected);
    }
  }

  supportsLocalStorage() {
    try {
      return typeof Storage !== 'undefined';
    } catch {
      return false;
    }
  }

  isCustomerLoggedIn() {
    return window.ShopifyAnalytics?.meta?.page?.customerId ||
           document.querySelector('[data-customer-id]')?.dataset.customerId;
  }

  async syncToAccount(vehicles) {
    if (!this.isCustomerLoggedIn()) return;

    try {
      const formData = new FormData();
      formData.append('customer[note]', `Vehicles:${JSON.stringify(vehicles.slice(0, 5))}`);

      fetch('/account', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).catch(() => {});
    } catch (error) {}
  }
}

window.VehicleStorage = VehicleStorage;
